// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper___CCBZ","logoWrapper":"style_logoWrapper__f_S8n","logo":"style_logo__2zdD1","formWrapper":"style_formWrapper__1UgYg","image":"style_image__8BW2W"};